
import {
  defineComponent, reactive, computed,
} from 'vue';
import Button from 'primevue/button';
import SegmentationBlockOR from '@/components/segmentations/SegmentationBlockOR.vue';
import { store } from '@/store';
import { useI18n } from 'vue-i18n';
import validateSegmentProperty from '@/components/segmentations/utils/utils';

export default defineComponent({
  name: 'SegmentationBlockAND',
  components: {
    SegmentationBlockOR,
    Button,
  },

  props: {
    blockAnd: {
      type: Array,
      required: false,
      default: () => [],
    },

    indexBlockAnd: {
      type: Number,
      required: true,
    },

    size: {
      type: String,
      required: false,
      default: '',
    },

    theme: {
      type: String,
      required: false,
      default: '',
    },

    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  setup(props) {
    const { t } = useI18n();
    const dataBlockAND = reactive(props.blockAnd);

    const currentSegmentConfig = computed(() => store.getters['segmentationsEditor/getCurrentSegmentConfig']);
    const paddingSize = computed(() => (props.size === 'small' ? '1' : '2'));

    const addBlockOR = async () => {
      if (currentSegmentConfig.value) {
        const { segmentId } = currentSegmentConfig.value.configProperty;
        const validation = await validateSegmentProperty(currentSegmentConfig.value.configProperty, currentSegmentConfig.value.propertyDefinition);
        if (validation && !validation.success) {
          store.commit('segmentationsEditor/pushError', { type: 'segments', value: { segmentId, value: validation.validate.value } });
          return false;
        }
        store.commit('segmentationsEditor/removeError', { type: 'segments', id: 'segmentId', value: segmentId });
        store.commit('segmentationsEditor/setRefreshContactsNumber', true);
      }
      const { indexBlockAnd } = props;
      store.commit('segmentationsEditor/addBlockOR', indexBlockAnd);
      store.commit('segmentationsEditor/setCurrentSegmentConfig', null);
    };

    const moveBlockOrToBlockAnd = (fromIndexBlockOR: any) => {
      const { indexBlockAnd } = props;
      store.commit('segmentationsEditor/moveBlocksORtoBlockAND', {
        indexBlockAND: indexBlockAnd,
        fromIndexBlockOR,
      });
      store.commit('segmentationsEditor/setRefreshContactsNumber', true);
    };

    return {
      t,
      dataBlockAND,
      paddingSize,
      addBlockOR,
      moveBlockOrToBlockAnd,
      readonly: props.readonly,
    };
  },
});
